
import Save from "./Save.vue";
import BreakpointsSelection from "./BreakpointsSelection.vue";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import UndoRedo from "./UndoRedo.vue";
import PreviewContentChooserDialog from "./PreviewChooser/PreviewContentChooserDialog.vue";
import DocumentChooser from "./DocumentChooser/DocumentChooser.vue";
import IconButton from "@/components/UI/IconButton.vue";
import SettingsDropdown from "@/components/Builder/TopBar/SettingsDropdown.vue";
import { isUiPanelOpen, toggleUiPanel } from "@/lib/panels/panels";
import { keyboardShortcuts } from "@/lib/keyboard-shortcuts/keyboard-shortcuts";
import { KEYBOARD_SHORTCUTS } from "@/lib/keyboard-shortcuts/global-shortcuts";
import { configStore, uiStore } from "@/store/store";
import { setScaleToFitAndGetSettings } from "@/lib/ui-preference/ui-preference";
import TopBarSection from "@/components/Reusable/AppLayout/TopBar/TopBarSection.vue";
import Exit from "@/components/Builder/TopBar/Exit.vue";
import AddButton from "@/components/Builder/TopBar/AddButton.vue";
import TopBar from "@/components/Reusable/AppLayout/TopBar/TopBar.vue";
import UpgradeToPro from "@/components/Subscription/UpgradeToPro.vue";
import { Breakpoint } from "@/types/breakpoints";
import OxygenMenuDropdown from "@/components/Builder/TopBar/OxygenMenuDropdown.vue";
import PreviewSize from "@/components/Builder/TopBar/PreviewSize.vue";
import InlineEditorTopbarIndicator from "@/components/Canvas/InlineEditor/InlineEditorTopbarIndicator.vue";

@Component({
  components: {
    InlineEditorTopbarIndicator,
    PreviewSize,
    TopBar,
    Exit,
    AddButton,
    TopBarSection,
    SettingsDropdown,
    BreakpointsSelection,
    Save,
    UndoRedo,
    PreviewContentChooserDialog,
    DocumentChooser,
    IconButton,
    UpgradeToPro,
    OxygenMenuDropdown
  }
})
export default class BuilderTopBar extends Vue {
  get shouldShowUpgradeToProButton() {
    return configStore.subscriptionMode === "free";
  }

  get isPreviewMode() {
    return uiStore.isPreviewMode;
  }

  togglePreviewMode() {
    uiStore.togglePreviewMode();
  }

  toggleElementProperties() {
    toggleUiPanel("elementproperties");
  }

  get isElementPropertiesOpen() {
    return isUiPanelOpen("elementproperties");
  }

  get isOxySelectorsPanelOpen() {
    return isUiPanelOpen("oxySelectors");
  }

  get isVariablesPanelOpen() {
    return isUiPanelOpen("variables");
  }

  toggleStructurePanel() {
    toggleUiPanel("structure");
  }

  toggleOxySelectorsPanel() {
    toggleUiPanel("oxySelectors");
  }

  toggleVariablesPanel() {
    toggleUiPanel("variables");
  }

  get isStructurePanelOpen() {
    return isUiPanelOpen("structure");
  }

  get isAiEnabled() {
    return configStore.ai?.enabled;
  }

  get isAiPanelOpen() {
    return isUiPanelOpen("ai");
  }

  toggleAiPanel() {
    toggleUiPanel("ai");
  }

  get activeElementId() {
    return uiStore.activeElementId;
  }

  get isInlineEditing() {
    return uiStore.isInlineEditing;
  }

  get currentBreakpoint() {
    return uiStore.currentBreakpoint;
  }

  set currentBreakpoint(breakpoint: Breakpoint) {
    uiStore.changeBreakpoint(breakpoint);
  }

  mounted() {
    keyboardShortcuts.register(KEYBOARD_SHORTCUTS.CMD_SHIFT_S, () =>
      setScaleToFitAndGetSettings(
        uiStore.settings.scaleToFit !== "SCALED_TO_FIT"
      )
    );
  }

  beforeDestroy() {
    keyboardShortcuts.unbind(KEYBOARD_SHORTCUTS.CMD_SHIFT_S);
  }

  get builderMode() {
    return configStore.builderMode;
  }
}
